<template>
  <div class="company">
    <div class="tixing">
      <h4>{{ $t('common.importantremind') }}</h4>
      <p class="first">
        {{ $t('exhiInformat.remind1') }}
      </p>
      <p>{{ $t('common.suggest1') }}<i>{{ $t('exhiInformat.date') }}</i>{{ $t('common.suggest2') }}</p>
    </div>
    <!-- 表单 -->
    <div class="formaction">
      <div class="text">
        <div class="text_box">
          <p>
            {{ $t('exhiInformat.cnname') }}：<span>{{ companyData.companyNameC }}</span>
          </p>
          <!-- <p>
            {{ $t('exhiInformat.enname') }}：<span>{{ companyData.companyNameE }}</span>
          </p> -->
          <p class="three">
           <span>{{ $t('exhiInformat.type') }}：</span> <span>{{ companyData.enteProperty }}</span>
          </p>
          <p>
            <i>*</i>{{ $t('exhiInformat.connection') }}：<span>010-64212207</span>
          </p>
        </div>
      </div>
      <!-- 表单控件 -->
      <div class="formsubmit">
        <el-form
          ref="form"
          :model="companyData"
          label-width="200px"
          size="mini"
          :rules="rules"
        >
          <el-form-item :label="$t('exhiInformat.enname')">
            <el-input
              v-model="companyData.companyNameE"
              class="input"
              :placeholder="$t('common.placeholder')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('exhiInformat.address')">
            <el-input
              v-model="companyData.addressC"
              class="input"
              :placeholder="$t('common.placeholder')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('exhiInformat.postCode')">
            <el-input
              v-model="companyData.postCode"
              class="input"
              :placeholder="$t('common.placeholder')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('exhiInformat.telephone')">
            <el-input
              v-model="companyData.telephone"
              class="input"
              :placeholder="$t('common.placeholder')"
            ></el-input>
            <p>{{ $t('common.forshow') }}</p>
          </el-form-item>
          <el-form-item label="E-mail：">
            <el-input
              v-model="companyData.email"
              class="input"
              :placeholder="$t('common.placeholder')"
            ></el-input>
            <p>{{ $t('common.forshow') }}</p>
          </el-form-item>
          <el-form-item :label="$t('exhiInformat.url')">
            <el-input
              v-model="companyData.comUrl"
              class="input"
              :placeholder="$t('common.placeholder')"
            ></el-input>
          </el-form-item>

          <!--Logo·中文-->
          <el-form-item :label="$t('exhiInformat.cnlogo')" prop="comCover">
            <div
              :style="{
                background:
                  'url(' +
                  spliceUrl(companyData.comCover) +
                  ')#f1f1f1 no-repeat center center /contain',
              }"
              class="upload-logo"
            >
              <img
                v-if="companyData.comCover"
                alt="删除"
                src="../../../static/icon_del.png"
                @click="deleteImg('comCover')"
              />
              <el-upload
                :action="imgbaseUrl + '/hz/frontCommon/upload'"
                :before-upload="beforeUpload"
                :headers="getToken()"
                :on-error="handleError"
                :on-success="handlecomCover"
                :show-file-list="false"
                class="upload-demo"
                name="file"
              >
                <div class="el-upload__text">{{ $t('common.selectfile') }}</div>
              </el-upload>
            </div>
            <p class="tishi">
              {{ $t('common.uploadimg1', { format: 'jpg, png, gif',recomsize:'693*399', filesize:'2M'}) }}
            </p>
          </el-form-item>

          <!--Logo英文-->
          <el-form-item :label="$t('exhiInformat.enlogo')">
            <div
              :style="{
                background:
                  'url(' +
                  spliceUrl(companyData.remarks) +
                  ')#f1f1f1 no-repeat center center /contain',
              }"
              class="upload-logo"
            >
              <img
                v-if="companyData.remarks"
                alt="删除"
                src="../../../static/icon_del.png"
                @click="deleteImg('remarks')"
              />
              <el-upload
                :action="imgbaseUrl + '/hz/frontCommon/upload'"
                :before-upload="beforeUpload"
                :headers="getToken()"
                :on-error="handleError"
                :on-success="handleremarks"
                :show-file-list="false"
                class="upload-demo"
                name="file"
              >
                <div class="el-upload__text">{{ $t('common.selectfile') }}</div>
              </el-upload>
            </div>
            <p class="tishi">
              {{ $t('common.uploadimg1', { format: 'jpg, png, gif',recomsize:'693*399', filesize:'2M'}) }}
            </p>
          </el-form-item>

          <el-form-item :label="$t('exhiInformat.cnintroduction')" prop="column17">
            <el-input
              v-model="companyData.column17"
              :rows="10"
              type="textarea"
              @input="inputArea"
            ></el-input>
            <p>
              {{ $t('common.inputarea1') }}<span>{{ currentLength }}</span
              >{{ $t('common.inputarea2',{ Num: '1000' }) }}
            </p>
          </el-form-item>
          <el-form-item :label="$t('exhiInformat.enintroduction')">
            <el-input
              v-model="companyData.column18"
              :rows="10"
              type="textarea"
              @input="inputArea1"
            ></el-input>
            <p>
              {{ $t('common.inputarea1') }}<span>{{ EcurrentLength }}</span
              >{{ $t('common.inputarea2',{ Num: '1000' }) }}
            </p>
          </el-form-item>

          <!--视频封面-->
          <el-form-item :label="$t('exhiInformat.videoCover')">
            <div
              :style="{
                background:
                  'url(' +
                  spliceUrl(companyData.column23) +
                  ')#f1f1f1 no-repeat center center /contain',
              }"
              class="upload-logo video"
            >
              <img
                v-if="companyData.column23"
                alt="删除"
                src="../../../static/icon_del.png"
                @click="deleteImg('column23')"
              />
              <el-upload
                :action="imgbaseUrl + '/hz/frontCommon/upload'"
                :before-upload="beforeUpload"
                :headers="getToken()"
                :on-error="handleError"
                :on-success="handlecolumn23"
                :show-file-list="false"
                class="upload-demo"
                name="file"
              >
                <div class="el-upload__text">{{ $t('common.selectfile') }}</div>
              </el-upload>
            </div>
            <p class="tishi">
<!--              格式：jpg, png, gif; 建议尺寸：800*450px; 大小：2M内-->
              {{ $t('common.uploadimg1', { format: 'jpg, png, gif',recomsize:'800*450', filesize:'2M'}) }}
            </p>
          </el-form-item>

          <!-- 上传视频 -->
          <el-form-item :label="$t('exhiInformat.uploadvideocn')">
            <i class="select" @click="videoUploadTips()">{{ $t('common.selectfile') }}</i>
            <p>
<!--                格式：mp4, mov; 大小：100M内，只能上传一个文件，重复上传会替换视频-->
              {{ $t('common.uploadvideo', { format: 'mp4, mov', filesize:'100M'}) }}
            </p>
            <p>{{ $t('common.tips') }}</p>
            <a :href='eshowUrl' style="text-decoration: none;color:rgb(60, 137, 226)"><h4>{{ $t('common.jumpUrl')}}</h4></a>
            <el-upload
              :action="imgbaseUrl + '/hz/frontCommon/upload'"
              :before-upload="videobeforeUpload"
              :file-list="fileList"
              :headers="getToken()"
              :on-error="handleError"
              :on-preview="playVideo"
              :on-success="handlecolumn25"
              :on-remove="handleRemove"
              class="avatar-uploader"
              name="file"
              ref="uploadVideo"
            >

            </el-upload>
          </el-form-item>

          <!--二维码-->
          <el-form-item :label="$t('exhiInformat.uploadwx')">
            <div
              :style="{
                background:
                  'url(' +
                  spliceUrl(companyData.column16) +
                  ')#f1f1f1 no-repeat center center /contain',
              }"
              class="upload-logo qrcode"
            >
              <img
                v-if="companyData.column16"
                alt="删除"
                src="../../../static/icon_del.png"
                @click="deleteImg('column16')"
              />
              <el-upload
                :action="imgbaseUrl + '/hz/frontCommon/upload'"
                :before-upload="qrbeforeUpload"
                :headers="getToken()"
                :on-error="handleError"
                :on-success="handlecolumn16"
                :show-file-list="false"
                class="upload-demo"
                name="file"
              >
                <div class="el-upload__text">{{ $t('common.selectfile') }}</div>
              </el-upload>
            </div>
            <p class="tishi">{{ $t('common.uploadimg2',{recomsize:'258*258'}) }}</p>
          </el-form-item>
          <el-button type="primary" @click="submit('form')">{{ $t('common.submit') }}</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../api/exhibitor";
import { editexhition, getExhition } from "../../../../api/exhibitor";
import { eshowURL,forMat, intercept } from "../../../../utils/common";

export default {
  name: "company",

  data() {
    var validatorComCover = (rule, value, callback) => {
      // console.log(this.companyData.comCover);
      if (!this.companyData.comCover) {
        callback(new Error(this.$t('dialog.message')));
      } else {
        callback();
      }
    };
    return {
      imgbaseUrl: "",
      //公司信息
      companyData: {},
      flag: true,
      //公司介绍文字长度
      currentLength: "1000",
      //英文介绍文字长度
      EcurrentLength: "1000",
      fileList: [],
      background: {},
      eshowURL:eshowURL(),
      rules: {
        // comCover: [
        //   {
        //     required: true,
        //     message: "公司Logo·中文不能为空",
        //     trigger: "blur",
        //     validator: validatorComCover,
        //   },
        // ],
        // column17: [
        //   { required: true, message: "公司介绍·中文不能为空", trigger: "blur" },
        // ],
      }
    };
  },

  components: {},

  created() {
    this.getExhition();
    this.imgbaseUrl = forMat();
  },

  methods: {
    handleRemove(file, fileList){

      this.fileList=[];
      this.companyData.column25=''

    },
    //删除图片
    deleteImg(param) {
      this.companyData[param] = "";
      this.$forceUpdate();
      // console.log(this[`${param}`], param);
    },

    // 点击弹窗播放视频
    playVideo(src) {
      let video;
      // console.log(src);
      if (src.url) {
        //如果之前上传过视频
        video = src.url;
      } else if (src.response.code == 200) {
        //上传后直接点击列表播放
        video = this.imgbaseUrl + src.response.data.url;
      } else {
        return false;
      }
      // var page = window.open();
      // var html =
      //   "<body style='background:black'> <div style='width:80%;margin:auto;'> <video controls width='100%' height='90%' autoplay src='" +
      //   video +
      //   "'></video></div></body>";
      // page.document.write(html);

      // var vdo = document.getElementById("videoPlay");
      // if (vdo.paused) {
      //   vdo.play();
      // } else {
      //   vdo.pause();
      // }
    },

    spliceUrl(img) {
      if(img.indexOf("http")  == -1){
        return this.imgbaseUrl + img;
      }else{
        return  img;
      }
      
    },

    getToken() {
      const a = localStorage.getItem("token");
      // console.log(a);
      let token = {};
      token.token = a;
      return token;
    },

    //获取展商信息
    async getExhition() {
      this.fileList = []
      try {
        let { data } = await getExhition();
        // console.log(data);
        this.companyData = data.data;
        this.eshowUrl = this.eshowURL+'/#/exhibition_det?id='+this.companyData.id
        console.log(this.eshowUrl);
        if (this.companyData.column25) {
          //视频文件数据
          this.fileList.push({
            name: intercept(this.companyData.column25),
            url: this.imgbaseUrl + this.companyData.column25,
          });
        }
      } catch (e) {
        console.log("1", e);
      }
    },

    handleError(file) {
      console.log("上传失败！", file);
      this.$messsage.error("上传失败！");
    },

    //上传前校验
    beforeUpload(file) {
      // console.log(file)
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1); //获取文件后缀
      const extension = testmsg === "jpg";
      const extension2 = testmsg === "png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension2) {
        this.$message({
          message:this.$t('dialog.message1'),
          type: "warning",
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message:this.$t('dialog.message2'),
          type: "warning",
        });
        return false;
      }
    },

    //中文logo
    handlecomCover(res, file) {
      // console.log(file)
      if (res.code == 200) {
        const { url } = res.data;
        this.companyData.comCover = url;
        this.$forceUpdate();
      }
    },

    //英文logo
    handleremarks(res, file) {
      // console.log(file)
      if (res.code == 200) {
        const { url } = res.data;
        this.companyData.remarks = url;
        this.$forceUpdate();
      }
    },

    //视频封面
    handlecolumn23(res, file) {
      // console.log(file)
      if (res.code == 200) {
        const { url } = res.data;
        this.companyData.column23 = url;
        this.$forceUpdate();
      }
    },

    //二维码上传前校验
    qrbeforeUpload(file) {
      // console.log(file)
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1); //获取文件后缀s
      if (!this.isAssetTypeAnImage(testmsg)) {
        this.$message({
          message: this.$t('dialog.message3'),
          type: "warning",
        });
        return false;
      }
    },

    //二维码
    handlecolumn16(res, file) {
      // console.log(file)
      if (res.code == 200) {
        const { url } = res.data;
        this.companyData.column16 = url;
        this.$forceUpdate();
      }
    },

    //验证是否是图片格式
    isAssetTypeAnImage(ext) {
      return (
        [
          "png",
          "jpg",
          "jpeg",
          "bmp",
          "gif",
          "webp",
          "psd",
          "svg",
          "tiff",
        ].indexOf(ext.toLowerCase()) !== -1
      );
    },

    //视频改变 列表只显示一条
    handleChange(file, fileList) {
      // console.log(fileList);
      this.fileList = fileList.slice(-1);
    },

    //上传视频
    handlecolumn25(res, file, fileList) {
      // console.log(fileList);
      if (res.code == 200) {
        const { url } = res.data;
        this.companyData.column25 = url;
        this.fileList = fileList.slice(-1);
        // this.fileList = [];
        // this.fileList = [{name: res.data.name, url: this.imgbaseUrl + res.data.url}]
        // console.log('shipin',this.fileList)
        this.$forceUpdate();
      }
    },
    videoUploadTips() {
      let self = this;
      // console.log(this.fileList);
      if (this.fileList.length > 0) {
        this.$confirm(this.$t('dialog.confirm'), this.$t('dialog.sureMess'), {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t('dialog.sure'),
          cancelButtonText:  this.$t('dialog.cancel'),
        })
          .then(() => {
            self.$refs["uploadVideo"].$refs["upload-inner"].handleClick();
          })
          .catch((action) => {});
      }else{
        self.$refs["uploadVideo"].$refs["upload-inner"].handleClick();
      }
    },

    //上传前校验
    videobeforeUpload(file) {
      // console.log(file)
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1); //获取文件后缀
      const extension = testmsg === "mp4";
      const extension2 = testmsg === "mov";
      const isLt2M = file.size / (1024 * 1024) < 100;
      if (!extension && !extension2) {
        this.$message({
          message: this.$t('dialog.message4'),
          type: "warning",
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message:this.$t('dialog.message5'),
          type: "warning",
        });
        return false;
      }
    },

    async editexhition() {
      const params = {
        id: this.companyData.id,
        // companyNameC: this.companyData.companyNameC,
        companyNameE: this.companyData.companyNameE,
        // enteProperty: this.companyData.enteProperty,
        // unitAbbreviation: this.companyData.unitAbbreviation,
        addressC: this.companyData.addressC,
        // addressE: this.companyData.addressE,
        postCode: this.companyData.postCode,
        telephone: this.companyData.telephone,
        email: this.companyData.email,
        comUrl: this.companyData.comUrl,
        column17: this.companyData.column17,
        column18: this.companyData.column18,
        column16: this.companyData.column16,
        column23: this.companyData.column23,
        column25: this.companyData.column25,
        comCover: this.companyData.comCover,
        remarks: this.companyData.remarks,
      };
      try {
        // console.log('test', params)
        let { data } = await editexhition(params);
        // console.log(data)
        if (data.code === 200) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.getExhition()
        } else {
          this.$message.error(data.msg);
        }
      } catch (e) {
        this.$message.error(e);
      }
    },

    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(valid);
          this.editexhition();
        } else {
          // this.$message.error("请检查必填项是否填写");
          // console.log("error submit!!");
          return false;
        }
      });
    },

    //监听文本框长度
    inputArea() {
      if (this.companyData.column17.length < 1000) {
        this.currentLength = 1000 - this.companyData.column17.length;
      } else {
        this.currentLength = 0;
        this.companyData.column17 = this.companyData.column17.slice(0, 1000);
      }
    },
    inputArea1() {
      if (this.companyData.column18.length < 1000) {
        this.EcurrentLength = 1000 - this.companyData.column18.length;
      } else {
        this.EcurrentLength = 0;
        this.companyData.column18 = this.companyData.column18.slice(0, 1000);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.input {
  width: 363px;
}
.company {
  box-sizing: border-box;
  padding: 0 43px 8px 26px;
  .tixing {
    background: #f6f6f7;
    padding: 10px 30px;
  }

  h4 {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff190c;
    line-height: 19px;
    margin-bottom: 8px;
  }

  p {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 19px;

    i {
      color: red;
      font-style: normal;
    }
  }

  .first {
    margin-bottom: 19px;
  }

  .text {
    border-bottom: 1px solid #e9e9e9;
    margin-top: 43px;
    padding-bottom: 17px;

    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 19px;
    }

    p:last-child {
      margin-left: 95px;

      span {
        color: #006fb8;
      }
    }

    .text_box {
      display: flex;
      // border: 1px solid red;
      width: 500px;
      flex-direction: column;
      justify-content: flex-start;
      // margin: 0 auto;
      margin-left: 98px;

      p {
        margin-bottom: 18px;
      }

      .three {
        // margin-left: 31px;
        span:first-child{
          text-align: right;
          margin-left:31px ;
        }
        span{
          width: fit-content;
          display:inline-block;
        }
      }
    }
  }

  .formsubmit {
    width: 830px;
    // margin: 0 auto;
    margin-top: 17px;

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: skyblue;
      // border: 1px solid red;
      width: 318px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }

    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }

    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 19px;

      span {
        color: red;
      }
    }

    .select {
      display: block;
      font-style: normal;
      width: 95px;
      // height: 28px;
      padding:5px;
      line-height:16px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      text-align: center;
      cursor: pointer;
    }

    .select1 {
      margin: 0 auto;
    }

    .box {
      width: 175px;
      height: 175px;
      // border: 1px solid red;
      background: #f1f1f1;
      display: flex;
      align-items: center;
    }

    .tishi {
      margin-top: 35px;
    }

    //上传组件样式
    .upload-logo {
      width: 363px;
      height: 209px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;

      &.qrcode {
        width: 200px;
        height: 200px;
      }

      &video {
        width: 384px;
        height: 216px;
      }

      img {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
      }

      .upload-demo {
        align-self: center;
      }
    }

    //隐藏上传列表删除图标 提示
    // ::v-deep .avatar-uploader {
    //   .el-upload-list {
    //     .el-upload-list__item:hover .el-icon-close {
    //       display: none;
    //     }

    //     .el-upload-list__item.is-success.focusing {
    //       .el-icon-close-tip {
    //         display: none;
    //       }
    //     }
    //   }
    // }
  }
}
</style>
<style scoped>
.formaction >>> .el-button--primary {
  min-width: 70px;
  min-height: 28px;
  background: #006fb8;
  text-align: center;
  margin-left: 190px;
  line-height: 4px;
}
</style>
<style scoped>
.upload-demo >>> .el-upload-dragger {
  /*width: 225px;*/
  /*height: 173px;*/
  /*background: #f1f1f1;*/
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  border-radius: 0px;
}

.upload-demo >>> .el-upload__text {
  width: fit-content;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    padding: 5px 0 5px 0;
    color: #666666;
    width: 93px;
    height: fit-content;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    line-height: 14px;
  /* line-height: 27px; */
}

/* >>> .avatar-uploader
  .el-upload-list
  .el-upload-list__item.is-success.focusing
  .el-icon-close-tip {
  　　display: none;
} */

/*>>>.el-upload-list__item.is-ready {*/
/*  display: none;*/
/*}*/
</style>
